import { ApplicationSettings } from '../settings';
import BaseComponentModel from './base-component-model';
import { Entry } from 'contentful';
import IShouldReturnEntity from '../../api-clients/IShouldReturnEntity';
import { ExcludedEntitiesHelper } from '../../api-clients/page-template-clients/helpers/excluded-entities-helper';
import { CallToAction, BackgroundImage } from '../course/ICourseContent';

export default class AdvertBannerComponentModel extends BaseComponentModel {
  application: string;
  headline: string;
  headlineTextColor: string;
  paragraph: string;
  paragraphTextColor: string;
  paragraphContainerColor: string;
  paragraphContainerColorOpacity: number;
  callToAction: CallToAction;
  backgroundImage: BackgroundImage;
  backgroundImageColor?: string;
  appSettings: ApplicationSettings;
  id?: string;

  protected shouldReturnEntity(entry: Entry<any>): IShouldReturnEntity {
    const requiredFields = ['headline', 'paragraph', 'backgroundImage', 'callToAction'];
    const notEmptyFields = [];

    return this.excludedEntitiesHelper.shouldComponentBeReturned(
      this.component,
      entry,
      requiredFields,
      notEmptyFields,
    );
  }

  public excludedEntitiesHelper = new ExcludedEntitiesHelper();
  public component = 'AdvertBanner';

  constructor(data: any, appSettings: ApplicationSettings) {
    super('advertBanner', appSettings);

    const advertBannerShouldReturn = this.shouldReturnEntity(data);

    if (!advertBannerShouldReturn.shouldReturn) {
      this.exclusionReasons.push(...advertBannerShouldReturn.shouldNotReturnReasons);
      this.isValid = false;
      return;
    }

    this.application = data.application ?? null;
    this.headline = data.headline ?? null;
    this.headlineTextColor = data.headlineTextColor ?? null;
    this.paragraph = data.paragraph ?? null;
    this.paragraphTextColor = data.paragraphTextColor ?? null;
    this.paragraphContainerColor = data.paragraphContainerColor ?? null;
    this.paragraphContainerColorOpacity = data.paragraphContainerColorOpacity ?? null;
    this.backgroundImageColor = data.backgroundImageColor ?? null;
    this.backgroundImage = data.backgroundImage ?? null;
    this.callToAction = data.callToAction ?? null;
    this.appSettings = appSettings;
    this.id = data.id;
  }
}
